import React, { useState } from 'react';
import Header from './Header';
import FullPageMenu from './FullPageMenu';
import Footer from './Footer';

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-[#f9f9f5] text-[#222222] selection:bg-[#E5DFD3] font-inter-display-medium flex flex-col justify-between relative">
      <Header onToggleMenu={handleToggleMenu} />

      <FullPageMenu isOpen={isMenuOpen} onClose={handleCloseMenu} />

      <main className="flex-1 pt-[45px] md:pt-[60px] lg:pt-[85px]">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
